import React from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import MainLayout from './layouts/MainLayout.jsx'
import DeliveryLocation from './pages/DeliveryLocation.jsx'
import Categories from './pages/Categories.jsx'
import Shops from './pages/Shops.jsx'
import ShopPricedItems from './pages/ShopPricedItems.jsx'
import Cart from './pages/Cart.jsx'
import OrderSuccess from './pages/OrderSuccess.jsx'
import SearchResults from './pages/SearchResults.jsx'
import './App.css'
import AdminHome from './pages/admin/AdminHome.jsx'
import ShopsTagsAdmin from './pages/admin/ShopsTagsAdmin.jsx'
import ShopsAdmin from './pages/admin/ShopsAdmin.jsx'
import DeliveryLocationsAdmin from './pages/admin/DeliveryLocationsAdmin.jsx'
import ShopShopItemMapsAdmin from './pages/admin/ShopShopItemMapsAdmin.jsx'
import ShopTagMapsAdmin from './pages/admin/ShopTagMapsAdmin.jsx'
import ShopLocationFeesAdmin from './pages/admin/ShopLocationFeesAdmin.jsx'
import AdminOrders from './pages/admin/AdminOrders.jsx'
import AdminOrderEdit from './pages/admin/AdminOrderEdit.jsx'
import AdminUsers from './pages/admin/AdminUsers.jsx'
import AdminUserOtps from './pages/admin/AdminUserOtps.jsx'
import FinancialRecords from './pages/admin/FinancialRecords.jsx'
import ShopDues from './pages/admin/ShopDues.jsx'
import GeneralConfigAdmin from './pages/admin/GeneralConfigAdmin.jsx'
import AdminStats from './pages/admin/AdminStats.jsx'
import ServicesAdmin from './pages/admin/ServicesAdmin.jsx'
import AdminPushNotifications from './pages/admin/AdminPushNotifications.jsx'
import MyOrders from './pages/MyOrders.jsx'
import OrderDetails from './pages/OrderDetails.jsx'
import UnifiedCatalog from './pages/UnifiedCatalog.jsx'
import PrivacyPolicy from './pages/PrivacyPolicy.jsx'
import AccountDeletion from './pages/AccountDeletion.jsx'
import Support from './pages/Support.jsx'
import Marketing from './pages/Marketing.jsx'
import CaptainOrderClaim from './pages/captain/CaptainOrderClaim.jsx'
import CaptainOffPlatformOrderClaim from './pages/captain/CaptainOffPlatformOrderClaim.jsx'
import MyCaptainDashboard from './pages/captain/MyCaptainDashboard.jsx'
import AdminCaptains from './pages/admin/AdminCaptains.jsx'
import AdminCaptainEdit from './pages/admin/AdminCaptainEdit.jsx'
import AdminCaptainDashboard from './pages/admin/AdminCaptainDashboard.jsx'
import AdminOffPlatformOrders from './pages/admin/AdminOffPlatformOrders.jsx'

function ProtectedRoute({ children }) {
    const hasDelivery = !!localStorage.getItem('deliveryLocation')
    if (!hasDelivery) {
        return <Navigate to="/delivery-location" replace />
    }
    return children
}

function HomeRedirect() {
    const hasDelivery = !!localStorage.getItem('deliveryLocation')
    return <Navigate to={hasDelivery ? '/categories' : '/delivery-location'} replace />
}

const router = createBrowserRouter([
    { path: '/privacy', element: <PrivacyPolicy /> },
    { path: '/account-deletion', element: <AccountDeletion /> },
    { path: '/support', element: <Support /> },
    { path: '/marketing', element: <Marketing /> },
    { path: '/delivery-location', element: <DeliveryLocation /> },
    {
        element: <MainLayout />,
        children: [
            { index: true, element: <HomeRedirect /> },
            {
                path: '/categories', element: (
                    <ProtectedRoute>
                        <Categories />
                    </ProtectedRoute>
                )
            },
            {
                path: '/shops/:tagId', element: (
                    <ProtectedRoute>
                        <Shops />
                    </ProtectedRoute>
                )
            },
            {
                path: '/shop-priced-items/:shopId', element: (
                    <ProtectedRoute>
                        <ShopPricedItems />
                    </ProtectedRoute>
                )
            },
            {
                path: '/catalog/:categoryId', element: (
                    <ProtectedRoute>
                        <UnifiedCatalog />
                    </ProtectedRoute>
                )
            },
            {
                path: '/cart', element: (
                    <ProtectedRoute>
                        <Cart />
                    </ProtectedRoute>
                )
            },
            {
                path: '/order-success', element: (
                    <ProtectedRoute>
                        <OrderSuccess />
                    </ProtectedRoute>
                )
            },
            {
                path: '/search', element: (
                    <ProtectedRoute>
                        <SearchResults />
                    </ProtectedRoute>
                )
            },
            {
                path: '/my-orders', element: (
                    <ProtectedRoute>
                        <MyOrders />
                    </ProtectedRoute>
                )
            },
        ],
    },
    { path: '/orders/:orderId', element: <OrderDetails /> },
    { path: '/orders/:orderId/:subOrderId', element: <OrderDetails /> },
    { path: '/admin', element: <AdminHome /> },
    { path: '/admin/shops-tags', element: <ShopsTagsAdmin /> },
    { path: '/admin/shops', element: <ShopsAdmin /> },
    { path: '/admin/delivery-locations', element: <DeliveryLocationsAdmin /> },
    { path: '/admin/shop-item-maps', element: <ShopShopItemMapsAdmin /> },
    { path: '/admin/shop-tag-maps', element: <ShopTagMapsAdmin /> },
    { path: '/admin/shop-location-fees', element: <ShopLocationFeesAdmin /> },
    { path: '/admin/orders', element: <AdminOrders /> },
    { path: '/admin/orders/:orderId', element: <AdminOrderEdit /> },
    { path: '/admin/admin-users', element: <AdminUsers /> },
    { path: '/admin/admin-user-otps', element: <AdminUserOtps /> },
    { path: '/admin/financial-records', element: <FinancialRecords /> },
    { path: '/admin/shop-dues', element: <ShopDues /> },
    { path: '/admin/general-config', element: <GeneralConfigAdmin /> },
    { path: '/admin/stats', element: <AdminStats /> },
    { path: '/admin/services', element: <ServicesAdmin /> },
    { path: '/admin/push-notifications', element: <AdminPushNotifications /> },
    { path: '/captain/orders/:orderId', element: <CaptainOrderClaim /> },
    { path: '/captain/dashboard', element: <MyCaptainDashboard /> },
    { path: '/admin/captains', element: <AdminCaptains /> },
    { path: '/admin/captains/:id', element: <AdminCaptainEdit /> },
    { path: '/admin/captains/:id/dashboard', element: <AdminCaptainDashboard /> },
    { path: '/captain/off-platform/:id', element: <CaptainOffPlatformOrderClaim /> },
    { path: '/admin/off-platform-orders', element: <AdminOffPlatformOrders /> },
    { path: '*', element: <Navigate to="/" replace /> },
])

export default function App() {
    return <RouterProvider router={router} />
}
